import HangTight from './hang-tight';

export default HangTight;
